import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-625cdd4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-recordstop-list" }
const _hoisted_2 = { class: "list-logo" }
const _hoisted_3 = {
  key: 0,
  class: "list-best"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-best-web" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "list-logo-img" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  ref: "listInfoRef",
  class: "list-info"
}
const _hoisted_9 = { class: "list-info-currency" }
const _hoisted_10 = { class: "list-info-time" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-opacity" }, "~", -1))
const _hoisted_12 = { class: "text-opacity" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.receiver.best)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("img", {
          src: _ctx.$tools.generateAvatar(_ctx.receiver.receiver),
          alt: ""
        }, null, 8, _hoisted_7)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("strong", {
          ref: "listInfoAmountRef",
          style: _normalizeStyle({fontSize: _ctx.listAmountFontSize + 'px'})
        }, " +" + _toDisplayString(_ctx.$tools.amountFormat(_ctx.receiver.amount, _ctx.receiver.decimal)) + " " + _toDisplayString(_ctx.receiver.demon), 5),
        _createElementVNode("p", {
          ref: "listInfoAddressRef",
          class: "list-info-address"
        }, _toDisplayString(_ctx.$tools.captureAddress(_ctx.receiver.receiver)), 513)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$tools.timeFormat(_ctx.receiver.receiveDate, 'HH:mm:ss')), 1)
      ])
    ], 512)
  ]))
}